var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-header"},[_c('router-link',{attrs:{"to":_vm.to}},[_c('ArrowLeft'),_c('Locale',{attrs:{"path":"navigation.back"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }